module.exports = __webpack_public_path__ + "static/media/tomia.c229eae6.png";